import { ProgramId } from 'modules/program';

import { ILob, searchWidgetConfig } from 'features/search-widget';

interface IGetLobsConfigOptions {
  programId: ProgramId;
}

interface IGetRequestedLobsConfigOptions extends IGetLobsConfigOptions {
  lobIds: string | string[];
}

function getLobsConfig({ programId }: IGetLobsConfigOptions): ILob[] {
  const { lobs } = searchWidgetConfig[programId];

  return lobs;
}

function getRequestedLobsConfig({ programId, lobIds }: IGetRequestedLobsConfigOptions): ILob[] {
  const lobs = getLobsConfig({ programId });

  const requestedLobIds = Array.isArray(lobIds) ? lobIds : lobIds?.split(',') ?? [];
  const requestedLobs = lobs.filter((lob) => requestedLobIds.includes(lob.id));

  return requestedLobs.length > 0 ? requestedLobs : lobs;
}

export { getLobsConfig, getRequestedLobsConfig };
